// extracted by mini-css-extract-plugin
export default {"retailerLogoWrapper":"RetailerLogo_retailerLogoWrapper__Y-aaz","retailerLogo":"RetailerLogo_retailerLogo__guRzB"};